function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import React, { createContext, useContext, useEffect, useLayoutEffect, useRef, useState } from "react";
import { Outlet, useLocation, useNavigation } from "react-router-dom";
import { useDispatch, useStore } from "react-redux";
import { isCancel } from "axios";
// utilities
import handleReportError from "../errors/handleReportError";
import useNavigate from "../../vendor/router/useNavigate";
import { ENSURE_LOADER_PERMISSISON_REDIRECT_ERROR_IDENTIFIER_MESSAGE, LOADER_FROM_SHOW_MODAL_ASYNC_STRING_IDENTIFIER } from "./utils";
var ModalManagerContext = /*#__PURE__*/ createContext(null);
export var useModalManagerContext = function() {
    return useContext(ModalManagerContext);
};
var showLogs = false; //todo delete if its all good
export default function ModalManagerProvider() {
    /**
     * --------------------
     * Hooks
     * --------------------
     */ var dispatch = useDispatch();
    var getState = useStore().getState;
    var pathname = useLocation().pathname;
    var abortControllerRef = useRef(new AbortController());
    var clearAsyncLoaderRef = useRef(null);
    var isFirstTime = useRef(true);
    /**
     * --------------------
     * Local state
     * --------------------
     */ var _useState = _sliced_to_array(useState(false), 2), isOpen = _useState[0], setIsOpen = _useState[1];
    var _useState1 = _sliced_to_array(useState([]), 2), modalStack = _useState1[0], setModalStack = _useState1[1];
    var _useState2 = _sliced_to_array(useState(null), 2), nextIndex = _useState2[0], setNextIndex = _useState2[1];
    var _useState3 = _sliced_to_array(useState(null), 2), closeCallback = _useState3[0], setCloseCallback = _useState3[1];
    var _useState4 = _sliced_to_array(useState(null), 2), nextModalToPush = _useState4[0], setNextModalToPush = _useState4[1];
    /**
     * --------------------
     * Effects
     * --------------------
     */ //? https://thoughtspile.github.io/2021/11/15/unintentional-layout-effect/
    //! https://kentcdodds.com/blog/useeffect-vs-uselayouteffect#one-special-case
    //! If we're using useEffect instead of useLayoutEffect,  in setModalStack, prevState would remain the old one and the error would be thrown when backing to page with showModal effect on mount
    //? Updates scheduled inside useLayoutEffect will be flushed synchronously, before the browser has a chance to paint.
    useLayoutEffect(function() {
        // if the pathname is changing, we reset everything
        showLogs && console.log(3939, "layouteffect pe pathname");
        if (modalStack.length > 0) {
            setModalStack([]);
            setNextIndex(null);
            setIsOpen(false);
        }
    //TODO 9393 11 sep -> vezi daca de aici poti sa rezolvi cumva err daca net slab + back cat se face submit de create bank din modala de partenr bank account
    // if (abortControllerRef.current) {
    //     console.log(3939, "imoloz dau abort din layout efect, eventual si clear daca i nev");
    //     abortControllerRef.current.abort(); // Abort any ongoing operation
    //
    //     cleanupAfterAborting(clearAsyncLoaderRef.current);
    // }
    }, [
        pathname
    ]);
    var navigation = useNavigation();
    useLayoutEffect(function() {
        if (navigation.state !== "loading") {
            showLogs && console.log(3939, "Xlayouteffect pe navigation NAVIGATION = LOADING - DAR NU FACE NIMIC CA NU E LOADING ACU:", navigation.state);
            return;
        }
        showLogs && console.log(3939, "Xlayouteffect pe navigation NAVIGATION = LOADING - acu era loading, daca are controller dau abort");
        // if (modalStack.length > 0) {
        //     setModalStack([]);
        //     setNextIndex(null);
        //     setIsOpen(false);
        // }
        //After a navigate (ex: Opened filters with showModalAsync, while its still loading, press creat button which calls navigate() ) ->
        // Without this effect the filters modal would open for a split-second (before the route changes)
        if (abortControllerRef.current) {
            showLogs && console.log(3939, "Ximoloz dau abort din layout effect NAVIGATION = LOADING, eventual si clear daca i nev");
            abortControllerRef.current.abort(); // Abort any ongoing operation
            cleanupAfterAborting(clearAsyncLoaderRef.current);
        }
    }, [
        navigation.state === "loading"
    ]);
    // on first render the modalStack will be [] and we don't want to reset anything
    useEffect(function() {
        if (isFirstTime.current) {
            isFirstTime.current = false;
            return;
        }
        return function() {
            abortControllerRef.current.abort();
            abortControllerRef.current = new AbortController();
        };
    }, []);
    /**
     * --------------------
     * Modal Manager actions
     * --------------------
     */ var _addToStack = function(param) {
        var component = param.component, initialProps = param.initialProps, onCloseAction = param.onCloseAction, isCalledFromShowModal = param.isCalledFromShowModal;
        setModalStack(function(prevState) {
            if (isCalledFromShowModal && prevState.length > 0) {
                //! The check moved from showModal, would still be thrown in other cases except when useLayoutEffect resets the state - useEffect would not reset the state yet
                throw new Error("Component cannot be initialized. You should never run showModal outside a route component. Use showModalAsync instead");
            }
            return _to_consumable_array(prevState).concat([
                {
                    component: component,
                    initialProps: initialProps,
                    onCloseAction: onCloseAction
                }
            ]);
        });
        // we set isOpen to true, to trigger the modal animation.
        setIsOpen(true);
    };
    var removeFromStack = function() {
        setModalStack(function(prevState) {
            if (Array.isArray(prevState) && prevState.length === 0) {
                console.warn("No need to remove modal from stack, user probably pressed the browser's back button");
                return [];
            }
            // nextIndex is the next modal stackIndex to be selected and rendered, however we need the current index to call the onCloseAction if exists
            var currentIndex = nextIndex + 1;
            // remove from stack
            var newState = prevState.slice(0, currentIndex);
            // if more than 1 modal is still left after the slice is applied, we trigger the opening animation. At this point we are sure that the closing animation is completed
            newState.length > 0 && setIsOpen(true);
            // if no closeCallback function is present and we have an onCloseAction, we run it
            if (prevState[currentIndex].onCloseAction && !closeCallback) {
                prevState[currentIndex].onCloseAction();
                // reset the nextIndex
                setNextIndex(null);
            }
            // if closeCallback is present, we run it.
            if (closeCallback) {
                closeCallback();
                // closeCallback the nextIndex
                setCloseCallback(null);
            }
            return newState;
        });
    };
    var goBack = function() {
        var toIndex = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : modalStack.length - 2;
        abortControllerRef.current.abort();
        abortControllerRef.current = new AbortController();
        // throw error if the next modal is itself or a modal that isn't in the stack
        if (toIndex >= modalStack.length) {
            throw new Error("Invalid value 'toIndex' received. 'toIndex' represents the index of the next Modal from the stack that you want to show and it can't be the current one/or doesn't exist anymore. Received: toIndex= ".concat(toIndex, "; Modal stack length: ").concat(modalStack.length));
        }
        // store the index of the modal stack that we want to show. It will be used in removeFromStack function
        setNextIndex(toIndex);
        // trigger the closing animation
        setIsOpen(false);
    };
    var navigate = useNavigate();
    // Called only after modal animation is completed and ONLY from the Modal component
    // We can either add a new modal or removing a modal.
    var goToNextModal = function() {
        // if adding a new modal to the stack ( it can happen only in showModalAsync function, when we already have other modals in the stack )
        if (nextModalToPush) {
            _addToStack(_object_spread({}, nextModalToPush));
            // resetting the variable to avoid a duplicate in the stack
            setNextModalToPush(null);
            return;
        }
        // if no nextModalToPush, it means that we are removing
        removeFromStack();
    };
    // this function will close and clear the modal stack
    var close = function(callback) {
        // if callback provided and not a function, return error
        if (callback && typeof callback !== "function") {
            throw new Error("Invalid callback provided. The callback should be a function, ".concat(typeof callback === "undefined" ? "undefined" : _type_of(callback), " received instead"));
        }
        // if callback provided, we store its reference to be used in removeFromStack function
        // this is used to override the onCloseAction function provided by the parent. Usefully when we want to exit the normal behaviour of the app
        if (callback && typeof callback === "function") {
            setCloseCallback(function() {
                return callback;
            });
        }
        // close the modal completely. -1 means that the next modal doesn't exist
        goBack(-1);
    };
    // add a new modal to the stack. The component is already imported and his initialProps are already loaded. This should be used only in a "Page" component.
    var showModal = function(param) {
        var component = param.component, initialProps = param.initialProps, onCloseAction = param.onClose;
        if (abortControllerRef.current) {
            abortControllerRef.current.abort(); // Abort any ongoing operation
            cleanupAfterAborting(clearAsyncLoaderRef.current);
        }
        //! Moved this inside the setModalStack from _addToStack since having it here, it would throw before the state set by showLayoutEffect has changed
        // if we already have a modal in the stack it means that we are not calling this method from a route page, and we throw an error. At this stage we should only use showModalAsync
        // if (modalStack.length > 0) {
        //     throw new Error(
        //         "Component cannot be initialized. You should never run showModal outside a route component. Use showModalAsync instead",
        //     );
        // }
        _addToStack({
            component: component,
            initialProps: initialProps,
            onCloseAction: onCloseAction,
            isCalledFromShowModal: true
        });
    };
    var cleanupAfterAborting = function(clearAsyncLoaderRef) {
        if (clearAsyncLoaderRef) {
            clearAsyncLoaderRef(); // clear loader of last showModalAsync call, if u had any before
            clearAsyncLoaderRef = null;
        }
    };
    // add a new modal with dynamic import to the stack, with data loading or not
    var showModalAsync = function(param) {
        var componentLoader = param.componentLoader, onClose = param.onClose, initialProps = param.initialProps, handleLoadError = param.handleLoadError, loaderProps = param.loaderProps, onAbortLoading = param.onAbortLoading;
        if (abortControllerRef.current) {
            abortControllerRef.current.abort(); // Abort any ongoing operation
        }
        cleanupAfterAborting(clearAsyncLoaderRef.current);
        var abortController = new AbortController();
        abortControllerRef.current = abortController;
        var signal = abortController.signal;
        // clearAsyncLoaderRef.current = onAbortLoading;
        clearAsyncLoaderRef.current = function() {
            try {
                if (onAbortLoading) {
                    onAbortLoading();
                }
            } catch (error) {
                //In case somehow the component is no longer rendered, avoid a bad setState, check if you can ever get this warn
                console.warn("Error in onAbortLoading:", error);
            }
        };
        componentLoader().then(function(result) {
            if (signal.aborted) {
                return; // Do nothing if the operation was aborted
            }
            if (!handleLoadError) {
                throw new Error("Could not find the error handler. ".concat(handleLoadError, " received instead "));
            }
            // if the component has his own loader, we run it
            if (result.loader) {
                result.loader(dispatch, abortController, getState, _object_spread({}, loaderProps), LOADER_FROM_SHOW_MODAL_ASYNC_STRING_IDENTIFIER).then(function(response) {
                    if (signal.aborted) {
                        return; // Do nothing if the operation was aborted
                    }
                    // if is first modal, add it to the stack
                    if (modalStack.length === 0) {
                        _addToStack(_object_spread({
                            component: result.default,
                            // attach the component results from the component loader
                            initialProps: _object_spread({}, initialProps, response)
                        }, onClose ? {
                            onCloseAction: onClose
                        } : null));
                        // setting isOpen to true will trigger the opening animation
                        setIsOpen(true);
                    } else {
                        // if there is any modal into the stack, we store the component so that it will be added to the stack when the animation is ended.
                        // This will happen in the goToNextModal function which is called after the previous modal animation is completed
                        setNextModalToPush(_object_spread({
                            component: result.default,
                            initialProps: _object_spread({}, initialProps, response)
                        }, onClose ? {
                            onCloseAction: onClose
                        } : null));
                        // setting isOpen to false will trigger the closing animation of the previous modal
                        setIsOpen(false);
                    }
                }).catch(function(error) {
                    if (isCancel(error)) {
                        //? After the component was already imported once, if the loader receives the abort command, don't rethrow the error
                        // throw error;
                        console.warn("cancelled modal-manager", error);
                    } else {
                        //todo 353 mai am nev de astea doua linii? cred ca da, daca crapa din alt motiv?
                        abortControllerRef.current.abort();
                        abortControllerRef.current = new AbortController();
                        //? Check if the error is a redirect (Only from ensure loader permission)
                        if (error.status === 302 && error.message === ENSURE_LOADER_PERMISSISON_REDIRECT_ERROR_IDENTIFIER_MESSAGE) {
                            var redirectUrl = error.location;
                            navigate(redirectUrl);
                            return;
                        }
                        // if any error occurs into the component loader, report to sentry and to the parent component
                        showLogs && console.log("moloz eroare n modalmanager e", error);
                        handleReportError(error);
                        handleLoadError(error); //! If handleLoadError calls mapErrorByHttpStatusCode, that will also call handleReportError.. is this ok?
                    }
                });
                return;
            }
            // if no component loader is provided, we add the new modal directly to the stack or to the nextModalToPush variable for future push into the stack
            // we have the same logic as above
            if (modalStack.length === 0) {
                // if (signal.aborted) {
                //     console.log(3939, "imoloz aborted inainte de setisopen true, dar nu returnez aici ");
                //     // return; // Do nothing if the operation was aborted
                // }
                _addToStack(_object_spread({
                    component: result.default,
                    initialProps: initialProps
                }, onClose ? {
                    onCloseAction: onClose
                } : null));
                setIsOpen(true);
            } else {
                setNextModalToPush(_object_spread({
                    component: result.default,
                    initialProps: initialProps
                }, onClose ? {
                    onCloseAction: onClose
                } : null));
                // setting isOpen to false will trigger the closing animation of the previous modal
                setIsOpen(false);
            }
        }).catch(function(error) {
            if (isCancel(error)) {
                //todo aici insa lasam sa arunce canceled ca pana acum? defapt.. intra vreodata pe cancelled la import??
                throw error;
            }
            //todo 353 mai am nev de astea doua linii? cred ca da, daca crapa din alt motiv?
            abortControllerRef.current.abort();
            abortControllerRef.current = new AbortController();
            // if any error occurs on the component import, report to sentry and to the parent component
            handleReportError(error);
            handleLoadError(error);
        });
    };
    // function to render the entire modal stack.
    var renderComponent = function() {
        // if no modal in the stack, return
        if (modalStack.length === 0) {
            return null;
        }
        return modalStack.map(function(modal, index) {
            var ModalComponent = modal.component;
            // only the last modal will be visible. IsHidden is a prop used in the Modal component, and it needs to be passed all the time from the parent
            var isHidden = modalStack.length !== index + 1;
            // render the modal with isHidden and initialProps props
            return /*#__PURE__*/ React.createElement(ModalComponent, {
                isHidden: isHidden,
                initialProps: modal.initialProps,
                key: index
            });
        });
    };
    // utility for different use cases
    var isFirstModal = modalStack.length === 1;
    return /*#__PURE__*/ React.createElement(ModalManagerContext.Provider, {
        value: {
            isOpen: isOpen,
            showModal: showModal,
            showModalAsync: showModalAsync,
            goToNextModal: goToNextModal,
            goBack: goBack,
            close: close,
            isFirstModal: isFirstModal
        }
    }, renderComponent(), /*#__PURE__*/ React.createElement(Outlet, null));
}
